import baseConfig, { Config } from "../../utils/config";

// Visual query demo - Snowflake inspired by demo1
const snowflakeConfig: Config = {
  ...baseConfig,
  AppName: "CADViewer Visual Query:",
  initFileName: "/content/custom/ggp/ggp-splash-05.svg",  // ""
  topBarLogo: "/ggp-logo.svg", // customer (GGP) logo — used as the customer logo on the Wing Analysis PDF header (replace public/ggp-logo.svg with the real logo)
  ServerBackEndUrl: "http://localhost:3000",
  //  ServerBackEndUrl: "https://cadviewer-conversion-server-ai-win-02.azurewebsites.net",
  //ServerBackEndUrl: "https://cadviewer-conversion-server-ai-lin-02-hddkdvedhyc8c7gp.swedencentral-01.azurewebsites.net",
  ServerLocation: "",
  //ServerUrl: "https://cadviewer-visual-query-react-ai-edbmbkb6d8gvgvck.swedencentral-01.azurewebsites.net",
  ServerUrl: "http://localhost:3001",
  debugMode: false, // enables CADViewer debug traces in the browser
  DisplayCoordinatesMenu: false,
  displayTopNavigationBar: false,
  setSpaceObjectsCustomMenu: false,
  hideLeftHamburgerMenu: false,
  enableDemoNavigation: true, // Set to true to display the demo navigation buttons
  BaseAttributes: {
    fill: "#ffd7f4",
    "fill-opacity": 0.0,  // Brookfield are zero opacity here
    stroke: "#CCC",
    "stroke-width": 0.1,
    "stroke-linejoin": "round",
    "stroke-opacity": 1.0,
  },
  HighlightAttributes: {
    fill: "#a4d7f4",
    "fill-opacity": 0.1,  // unsure what Zach did here, 0.3 ->0.1
    stroke: "#a4d7f4",
    "stroke-width": 0.2,
    "stroke-linejoin": "round",
    "stroke-opacity": 1.0,
  },
  SelectAttributes: {
    fill: "#5BBEF6",
    "fill-opacity": 0.2,  // unsure what Zach did here, 0.5 -> 0.2  
    stroke: "#5BBEF6",
    "stroke-width": 0.23,
    "stroke-linejoin": "round",
    "stroke-opacity": 1.0,
  },
  postFixServerToken: true,
  // Locations for property data (same pattern as demo1, adapt for Snowflake-backed dataset gateway)
  globalApplicationFilesLocation:
    "https://cvtemptesting1.blob.core.windows.net/test-cadviewer/json/application/",
  propertySVGFilesLocation:
    "https://cvtemptesting1.blob.core.windows.net/test-cadviewer/svg/",
  propertyJSONFilesLocation:
    "https://cvtemptesting1.blob.core.windows.net/test-cadviewer/json/property/",


  // Default property to Load
  defautlPropertyToLoad: {  // mall in Columbia, MD
    propertyNumber: "",// "4472",
    planName: "",// "LP1",
    planView: "",//"Base Plan",
  },


  enableQuickPdfPrint: true,
  enableAIChat: true,
  enableAIAssistantPictureInPicture: true, // Set to true to enable the Pop Out functionality for the AI Assistant
  useAIChatV5: true,
  useAIChatV4: false,
  chatResultDisplayMetrics: true,
  aiChatV5Endpoint: "http://localhost:3000/ai/proxy",
  //aiChatV5Endpoint: "https://cadviewer-conversion-server-ai-lin-02-hddkdvedhyc8c7gp.swedencentral-01.azurewebsites.net/ai/proxy",
  aiChatV5Provider: "snowflake-agent" as
    | "snowflake"
    | "python"
    | "snowflake-agent",
  aiChatV5Mode: "Test" as "Test" | "Prod",
  propertyJSONFilesEnableDistance: true,
  propertyJSONFilesEnableLayerColors: true,
  topPaneScrollDownTitle: "Choose information plan/layer:",
  displayTopPaneScrollDownButton: true,
  topRowItem1: "Property Name:",
  topRowItem2: "Property Number:",
  topRowItem3: "Plan Name:",
  enableRightJSONModalPanel: true,
  enableRightFileModalPanel: false,
  setCADViewerSkin: "light-skin",
  setBPLayerChange: true,
  serverSubFolder: "/drawings/dwg/",
  showOnlySubFolder: true,
  showLogoOnSideBarLeftPanel: true,
  cvjs_styleQTip_width: "320px",

  enableHelperMethods: true,
  enableHelpersMethodsGroup_Highlight: false,
  enableHelpersMethodsGroup_Group: false,
  enableHelpersMethodsGroup_Manipulate: false,
  enableHelpersMethodsGroup_Insert: false,
  enableHelpersMethodsGroup_CustomCanvas: false,
  enableHelpersMethodsGroup_SpaceArea: false,
  enableHelpersMethodsGroup_RedlineArea: false,
  enableHelpersMethodsGroup_VizQueryDemo: false,
  enableHelpersMethodsGroup_Brookfield: false,
  enableHelpersMethodsGroup_UrbanEdge: false,
  enableHelpersMethodsGroup_UicEdu: false,
  enableHelpersMethodsGroup_Insuremep: false,

  // Each question carries the scope it actually works in — clicking one switches
  // to that scope. Without this a first-time user, who lands on "Current Plan",
  // ran portfolio questions against a single plan and got empty or wrong answers.
  aiBaseQueries: [
    // 1 future tenant on Willowbrook LP1 vs 171 across the portfolio.
    { text: "Which stores has a future tenant? list current and future tenants", scope: "global" },
    { text: "How many malls are in the portfolio, list them with decreasing number of stores, include the state", scope: "global" },
    // Proximity reads the DISTANCES table, which is stored per plan. Apple is on
    // Willowbrook LP1 (space 1585); Lululemon, used previously, is not there at all.
    { text: "I need all stores within 110 feet from Apple with lease expiration before 2027", scope: "current" },
    { text: "Which tenants who are below their average square footage size over all malls by 10% or more and above their average total sales by 10% or more", scope: "global" },
    // Adjacency is also per plan.
    { text: "Find adjacent vacant or expiring spaces within the next 6 months that could be combined", scope: "current" },
    { text: "Provide the best options to combine adjacent spaces between 7,000 - 12,000 SF based on total rent and lease expiration", scope: "current" },
    { text: "Analyze all lease plans in the portfolio and recommend a prospective tenant for Space 1485 based on the size of the space and frequent co-tenants within 200 feet of the store-front", scope: "global" }
  ],
  cadviewerLicenseKey: "00110010 00110010 ",
  //cadviewerLicenseKey: "00110010 00110010 00110000 00110001 00110001 00111001 00111001 00110001 00110101 00110111 00110001 00110101 00111001 00110001 00110101 00110110 00110001 00110011 00111000 00110001 00110101 00110001 00110001 00110101 00110101 00110001 00110011 00110111 00110001 00110101 00110101 00110001 00110100 00110010 00110010 00110001 00110001 00110001 00110011 00111000 00110001 00110101 00110001 00110001 00110100 00110001 00110001 00110011 00111001 00110001 00110101 00111001 00110001 00110100 00111000 00110010 00110001 00110001 00110001 00110100 00110011 00110001 00110011 00111001 00110001 00110101 00110101 00110001 00110100 00110010 00110001 00110011 00110101 00110010 00110001 00110001 00110001 00110100 00110010 00110001 00110101 00110101 00110001 00110101 00111001 00110001 00110101 00110111 00110001 00110100 00110000 00110010 00110001 00110001 00110001 00110101 00111001 00110001 00110101 00110001 00110010 00110001 00110001 00110001 00110101 00110101 00110001 00110101 00110110 00110001 00110101 00111000 00110001 00110100 00110111 00110001 00110101 00111000 00110001 00110100 00111001 00110001 00110101 00111000 00110010 00110000 00110010 00110001 00110101 00110110 00110010 00110000 00110000 00110001 00110101 00110011 00110001 00110011 00111000 00110001 00110101 00110011 00110001 00110011 00111000 00110001 00110101 00110111 00110001 00110100 00111001 00110010 00110001 00110000 00110001 00110100 00110001 00110001 00110011 00110111 00110001 00110101 00110101 00110001 00110101 00110110 00110001 00110101 00110101 00110001 00110100 00110110 00110001 00110101 00110111 00110001 00110101 00110101 00110001 00110100 00110110 00110001 00110100 00110000 00110001 00110100 00110010 00110001 00110101 00111001 00110001 00110100 00111000 00110010 00110001 00110001 00110010 00110000 00111000 00110010 00110000 00110111 00110010 00110001 00110000 00110001 00110101 00111001 00110001 00110011 00110100 00110001 00110011 00111001 00110001 00110100 00110010 00110001 00110101 00110101 00110001 00110011 00110111 00110001 00110101 00110101 00110001 00110101 00111000 00110001 00110100 00110001 00110001 00110101 00110001 00110001 00110100 00110000 00110001 00110101 00110101 00110001 00110100 00110001 00110010 00110001 00110000 00110001 00110100 00110110 00110001 00110101 00110101 00110001 00110100 00110000 00110001 00111001 00110111 00110001 00110100 00111000 00110001 00110100 00110101 00110001 00110101 00110111 00110001 00110101 00111001 00110001 00110100 00111000 00110001 00110101 00110010 00110001 00110100 00110101 00110001 00110100 00110001 00110001 00110100 00110000 00110001 00111001 00110111 00110010 00110000 00110111 00110010 00110000 00110110 00110010 00110000 00110001 00110010 00110001 00110000 00110010 00110000 00111000 00110010 00110001 00110000 00110010 00110000 00111000 00110010 00110001 00110000 00110010 00110000 00110111 00110001 00111001 00110111 00110001 00110011 00110100 00110001 00110101 00110111 00110001 00110101 00111001 00110001 00110101 00110110 00110001 00110011 00111000 00110001 00110101 00110001 00110001 00110101 00110101 00110001 00110011 00110111 00110001 00110101 00110101 00110001 00110100 00110010 00110001 00110100 00110000 00110001 00110101 00110101 00110001 00110100 00110001 00110001 00110100 00110000 00110010 00110001 00110000 00110001 00110101 00111001 00110001 00110011 00110100 00110001 00110011 00111001 00110001 00110100 00110010 00110001 00110101 00110101 00110001 00110011 00110111 00110001 00110101 00110101 00110001 00110101 00111000 00110001 00110100 00110001 00110001 00110101 00110001 00110001 00110100 00110000 00110001 00110101 00110101 00110001 00110100 00110001 00110010 00110001 00110000 00110001 00110100 00110110 00110001 00110101 00110101 00110001 00110100 00110000 00110001 00111001 00111000 00110010 00110000 00110110 00110010 00110000 00111000 00110010 00110000 00110110 00110010 00110000 00110010 00110010 00110001 00110001 00110010 00110000 00111000 00110010 00110000 00110101 00110010 00110001 00110001 00110010 00110000 00110101 00110010 00110000 00110111",
  showTourInformationDialog: false,
  enableHelpButton1: false,
  helpbutton1: "Tech Docs",
  helpbutton1link: "https://cadviewer.com/cadviewertechdocs/",
  enableHelpButton2: false,
  helpbutton2: "User Manual",
  helpbutton2link: "https://cadviewer.com/cadviewerusermanual/",
  customHtmlHeaderContent: `
  `,
  enableLoginFeature: false, // SET THE logon interface for users
  enableSpaceTools: false,
  enableQuickActions: false,

  // Enable or disable the contextual menu (three dots) in ChatMessageDisplay
  enableChatMessageMenu: false, // Set to false to hide the menu in ChatMessageDisplay
  // Enable or disable each menu item in ChatMessageDisplay contextual menu
  enableMenuShowRawJson: false, // Show/hide the 'Show raw JSON' item
  enableMenuCopyRawJson: false, // Show/hide the 'Copy raw JSON' item
  enableMenuShowResults: true, // Show/hide the 'Show/Hide results' item

  // Button Colors Configuration
  // These values override the CSS defaults in index.css
  // You can customize button colors per-demo by setting this in demo config files
  // Or at runtime by loading from an external JSON file
  buttonColors: {
    // Primary buttons (dark blue) - used for main action buttons in the header
    primary: {
      bg: "#013429",  // #013429 - GGP GREEN    "#0d304f" Brookfield
      bgHover: "#013429", // #013429 - GGP GREEN    "#0f3557" Brookfield
      text: "#ffffff",
      ring: "#013429", // #013429 - GGP GREEN    "#0f3557" Brookfield
    },
    // Accent buttons (orange gradient) - used for AI chat button
    accent: {
      bg: "#f97316",
      bgHover: "#ea580c",
      text: "#ffffff",
      gradientFrom: "#fb923c",
      gradientTo: "#c2410c",
      ring: "#f97316",
    },
    // FAB (Floating Action Buttons) - used for space tools button
    fab: {
      bg: "#0f3557",
      bgHover: "#0d304f",
      text: "#ffffff",
      ring: "#0f3557",
    },
    // Subtle/secondary buttons - used for switch plan button
    subtle: {
      bg: "#fed7aa",
      bgHover: "#fdba74",
      text: "#c2410c",
    },
  },

  primaryColors: {
    50: "#e2e7eb",
    100: "#b7c2cd",
    200: "#879aab",
    300: "#577289",
    400: "#335370",
    500: "#013429",    // Brookfield #0f3557  GGP "#013429"
    600: "#013429",    // Brookfield #0d304f  GGP "#013429"
    700: "#013429",    // Brookfield #0b2846  GGP "#013429"
    800: "#013429",    // Brookfield #08223c  GGP "#013429"
    900: "#013429",    // Brookfield #04162c  GGP "#013429"
  },

  // Theme Colors Configuration
  // Override sidebar, panel, and layout colors independently from primary palette
  // If not set, sidebar/panel colors derive from the primary palette via CSS variables
  themeColors: {
    sidebarBackground: "#013429", // GGP "#013429", // Brookfield "#0f3557",  // defaults to var(--primary-500)
    // sidebarHamburgerBackground: "#0f3557",
    // sidebarTitle: "#f9f9f9",
    // sidebarSubtitle: "#efeff0",
    // bottomPanelBackground: "#ffffff",
    // rightActionBackground: "#0f3557",
  },
  omitSpaceObjectLayerHandling: true,     // IMPORTANT for GGP 11.15.14
// VISUAL QUERY PANEL CONTROLS
  ShowInformativeBottomPanel: true, // turn the the bottom panel on off
  ShowInformativeBottomPanelWhenClickInLeftPanel: true,
  ShowInformativeLeftPanel: false, // initia show the left side panel
  bottomPaneSliderMode: "aboveCADViewer", // withCADViewer, aboveCADViewer,
  bottomPaneDefaultHeight: 15, // (15)   percentage of screen height (2) min
  rightPanelDefaultWidth: 36, // (40) percentage of screen height
  leftPaneDefaultWidth: 17, // (17) percentage of screen height

  quickActionsConfig: {
    enableFinancialSummary: true, // Enable "Financial Summary" quick action
    enableOpportunityCost: true, // Enable "Opportunity Cost" quick action
    enableWingAnalysis: true, // Enable "Wing Analysis" quick action
    enableTenantRanking: true, // Enable "Tenant Ranking" quick action (single selection)
    enableTenantComparison: true, // Enable "Tenant Comparison" quick action (single selection)
  },

  // Wing Analysis PDF report options
  wingPdfConfig: {
    showGeneratedDate: true, // Show the "Generated: <date>" line in the Wing Analysis PDF
    includeCoverPage: false, // Keep the report's first page (title + wing space list)

  },
  generatedDateFormat: "MM/DD/YYYY HH:mm:ss", // Tokens: YYYY, YY, MM, DD, HH/hh, mm, ss, A/a
  use12HourTime: false,

};

export default snowflakeConfig;
